<template>
  <PreviewSheet>
    <div class="feature-card align-center flex-col gap-4">
      <div
        class="feature-card__icon-wrapper align-center flex-col justify-center"
      >
        <Component :is="icon" size="24" :style="iconStyle" />
      </div>
      <PreviewTypography
        :text="feature.title"
        variant="paragraphSmall"
        color="primary"
      />
      <PreviewTypography
        v-if="feature.description"
        :text="feature.description"
        variant="paragraphSmall"
        color="secondary"
      />
    </div>
  </PreviewSheet>
</template>

<script lang="ts" setup>
import { type Component, computed } from 'vue'

import { useMergedTheme } from '@/lib/builder/public/preview/mixins/useMergedThemeComp'
import PreviewSheet from '@/lib/builder/public/preview/PreviewSheet.vue'
import PreviewTypography from '@/lib/builder/public/preview/PreviewTypography.vue'

import { featureIcons as icons } from '../../../common/feature-icons'
import { type FeaturesSection } from '../../../WebsiteBuilder.types'

const props = defineProps<{
  feature: FeaturesSection['params']['features'][number]
}>()

const theme = useMergedTheme()

const iconStyle = computed(() => {
  return {
    color: theme.value?.colors.text.secondary,
  }
})

const icon = computed(() => {
  return icons[props.feature.icon] as Component
})
</script>

<style lang="scss" scoped>
.feature-card {
  padding: 12px 0;
  flex: 0 0 auto;
  text-align: center;
  width: 220px;

  &__icon-wrapper {
    width: 24px;
    height: 24px;
    flex-shrink: 0;
  }
}
</style>
